import { useState, useEffect } from 'react';

const DEFAULT_LINK = 'https://apps.apple.com/app/apple-store/id1447330651?pt=2056961&ct=web&mt=8';

export default function useSmartScriptLink() {
  const [link, setLink] = useState(DEFAULT_LINK);

  useEffect(() => {
    const update = () => {
      if (window.AF_SMART_SCRIPT_RESULT && window.AF_SMART_SCRIPT_RESULT.clickURL) {
        setLink(window.AF_SMART_SCRIPT_RESULT.clickURL);
        return true;
      }
      return false;
    };
    if (!update()) {
      const id = setInterval(() => {
        if (update()) {
          clearInterval(id);
        }
      }, 500);
      return () => clearInterval(id);
    }
  }, []);

  return link;
}
